<app-configuration-page
  title="Import History"
  description="Bring past lesson and payment history into the studio from a spreadsheet."
  [breadcrumbs]="[{ label: 'Simple Import' }, { label: 'Import History' }]">

  <app-simple-import-history
    (formChange)="onFormChange()"
    (submitSuccess)="onSubmitSuccess()">
  </app-simple-import-history>

</app-configuration-page>
